
export default class Timer {
	constructor(callback) {
		this.callback = callback;

		this.startTime = (new Date()).getTime();
		this.loopTime = 0;

		this.delta = 1;
		this.interval = null;
		this.sleepTimeout = null;
		this.setDeltaTime(1/60);
		this.sleep();
	}

	reset() {
		this.startTime = (new Date()).getTime();
	}

	update() {
		if (this.callback) {
			this.loopTime += this.delta;
			this.callback(this.loopTime);
		}
	}

	clear() {
		clearTimeout(this.sleepTimeout);
		clearInterval(this.interval);
	}

	setDeltaTime(delta) {
		this.clear();
		this.delta = delta;
		this.interval = setInterval(this.update.bind(this), 1000*this.delta);
	}

	wake() {
		clearTimeout(this.sleepTimeout);
		this.setDeltaTime(1/60);
	}

	sleep() {
		clearTimeout(this.sleepTimeout);
		this.sleepTimeout = setTimeout(() => {
			this.setDeltaTime(1/25);
		}, 2000);
	}

	get elapsed() {
		return ((new Date()).getTime() - this.startTime) / 1000;
	}
}
